import { render } from "./ApplySalonJoinPage.vue?vue&type=template&id=e72f0f6c&scoped=true"
import script from "./ApplySalonJoinPage.vue?vue&type=script&lang=js"
export * from "./ApplySalonJoinPage.vue?vue&type=script&lang=js"

import "./ApplySalonJoinPage.vue?vue&type=style&index=0&id=e72f0f6c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e72f0f6c"]])

export default __exports__